// PrintPDF.js
import { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "antd";
import "../css/loadprint.css";
import PDFAddressMain from "./PDFAddressMain";

function PrintPDFAddress({ dataTabelB }) {
  //PDF
  const [triggerPDF, setTriggerPDF] = useState(false);
  const conponentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "สติกเกอร์",
  });

  const handlePDF = () => {
    setTriggerPDF(true); // ตั้ง triggerPDF ที่นี่หลังจากได้รับข้อมูล
  };
  //โหลด PDF
  useEffect(() => {
    if (triggerPDF) {
      generatePDF();
      setTriggerPDF(false); // Reset the trigger
    }
  }, [triggerPDF, generatePDF]);

  return (
    <>
      <Button
        type="primary"
        onClick={handlePDF}
        style={{ backgroundColor: "Orange", borderColor: "Orange" }}
      >
        พิมพ์สติกเกอร์
      </Button>
      <div className="print-only" ref={conponentPDF}>
        <PDFAddressMain dataTabelB={dataTabelB} />
      </div>
    </>
  );
}
export default PrintPDFAddress;